// 받침에 따라 조사를 고른다 — 숫자·영문 대문자(약어)는 한국어로 읽고, 그 밖의 한글 아닌 글자는 받침 없음으로 본다.

// 숫자로 끝나면 한국어 읽기(영·일·이·삼·사·오·육·칠·팔·구)의 받침 번호 — 0 으로 끝나는 십·백·천·만도 ㄹ 아닌 받침이다.
const DIGIT_FINAL = [21, 8, 0, 16, 0, 0, 1, 8, 8, 0];

// 대문자 약어 끝 글자의 받침 번호(엘·알=ㄹ, 엠=ㅁ, 엔=ㄴ) — 「URL은」「CRM을」「SNS는」.
const LETTER_FINAL: Record<string, number> = { L: 8, R: 8, M: 16, N: 4 };

// 마지막 글자의 받침 번호(0 = 없음). 한글 음절·숫자·대문자가 아니면 0.
const finalOf = (word: string): number => {
  const last = word.trim().slice(-1);
  if (last >= "0" && last <= "9") return DIGIT_FINAL[Number(last)];
  if (last >= "A" && last <= "Z") return LETTER_FINAL[last] ?? 0;
  const code = last.charCodeAt(0) - 0xac00;
  if (Number.isNaN(code) || code < 0 || code > 11171) return 0;
  return code % 28;
};

// ㄹ 받침의 번호 — 「으로」 대신 「로」를 쓴다.
const RIEUL = 8;

// 빈 낱말에는 조사도 붙이지 않는다 — 「를 골랐습니다」 처럼 조사만 남지 않게.
const blank = (word: string): boolean => word.trim() === "";

export const objectJosa = (word: string): "을" | "를" | "" => (blank(word) ? "" : finalOf(word) === 0 ? "를" : "을");

export const subjectJosa = (word: string): "이" | "가" | "" => (blank(word) ? "" : finalOf(word) === 0 ? "가" : "이");

export const directionJosa = (word: string): "으로" | "로" | "" => {
  if (blank(word)) return "";
  const final = finalOf(word);
  return final === 0 || final === RIEUL ? "로" : "으로";
};

export const topicJosa = (word: string): "은" | "는" | "" => (blank(word) ? "" : finalOf(word) === 0 ? "는" : "은");
